class AddonService extends CustomElement {
    props = {
        productId: "",
        variantId: ""
    }

    constructor() {
        super();
    }

    monitorSetAccessibility() {
        let intervalId = setInterval(() => {
            this.setAccessibility()
        }, 1000);

        const { $serviceAddBtn } = this.refs;
        
        if ($serviceAddBtn.lenght > 0) {
            clearInterval(intervalId)
        }
    }

    get refs() {
        const $serviceAddBtn = $("#removal-service-modal .service-package__add-btn")

        return {
            $checkboxInput: this.$el.find('.addon-checkbox__input'),
            $serviceAddBtn
        }
    }

    mounted() {
        super.mounted();
        this.monitorSetAccessibility();

        const { $checkboxInput } = this.refs

        this.$el.click((e => {
            e.preventDefault();
            const serviceIncluded = $checkboxInput.is(':checked')

            if (!serviceIncluded) {
                $("#removal-service-modal").modal({
                    fadeDuration: 100,
                    modalClass: "",
                    closeText: "x"
                })
            }
            else {
                $checkboxInput.prop("checked", false)
            }
        }));
    }

    close() {
        $.modal.close();
    }

    setAccessibility() {
        const { $checkboxInput, $serviceAddBtn } = this.refs

        $serviceAddBtn.click(() => {
            $checkboxInput.prop("checked", true)

            this.close()
        })
    }
}

customElements.define('addon-service', AddonService);
